import React from 'react';

function usePrevious(value) {
    const ref = React.useRef();
    React.useLayoutEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
function usePreviousRef(value) {
    const ref = React.useRef();
    React.useLayoutEffect(() => {
        ref.current = value;
    });
    return ref;
}

function useCleanupRef(value) {
    const prev = usePrevious(value);
    const prevRef = React.useRef(value);
    if (prev)
        prevRef.current = Object.assign({}, prev);
    return prevRef;
}

function useLatest(value) {
    const box = React.useRef(Object.assign({}, value));
    const ref = React.useRef(value);
    ref.current = value;
    React.useLayoutEffect(() => {
        if (!(value != null && typeof value === 'object'))
            return;
        const obj = {};
        for (const k in value) {
            if (!value.hasOwnProperty(k))
                continue;
            if (typeof value[k] === 'function') {
                obj[k] = (...args) => ref.current[k](...args);
            }
            else {
                obj[k] = value[k];
            }
        }
        Object.assign(box.current, obj);
    });
    return box.current;
}

function useEffect(effect, deps, latest) {
    const latest_ = useLatest(latest);
    const prevRef = useCleanupRef(latest);
    React.useEffect(() => {
        const cleanup = effect(latest_);
        return cleanup == null ? cleanup : () => cleanup(prevRef.current);
    }, deps);
}

function useLayoutEffect(effect, deps, latest) {
    const latest_ = useLatest(latest);
    const prevRef = useCleanupRef(latest);
    React.useLayoutEffect(() => {
        const cleanup = effect(latest_);
        return cleanup == null ? cleanup : () => cleanup(prevRef.current);
    }, deps);
}

function usePureEffect(effect, deps, latest) {
    const prev = usePrevious(deps);
    const latest_ = useLatest(latest);
    const cleanupRef = useCleanupRef(latest);
    React.useEffect(() => {
        const cleanup = effect(latest_, deps, prev);
        return cleanup == null
            ? cleanup
            : () => cleanup(cleanupRef.current, deps);
    }, deps == null ? deps : Object.values(deps));
}

function usePureLayoutEffect(effect, deps, latest) {
    const prev = usePrevious(deps);
    const latest_ = useLatest(latest);
    const cleanupRef = useCleanupRef(latest);
    React.useLayoutEffect(() => {
        const cleanup = effect(latest_, deps, prev);
        return cleanup == null
            ? cleanup
            : () => cleanup(cleanupRef.current, deps);
    }, deps == null ? deps : Object.values(deps));
}

export { useCleanupRef, useEffect, useLatest, useLayoutEffect, usePrevious, usePreviousRef, usePureEffect, usePureLayoutEffect };
